import React from 'react';
import { StyledSpinner, StyledSpinnerContainer, StyledSpinnerOverlay } from './styled';

export interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    overlay?: boolean;
    message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
    size = 'medium', 
    overlay = false,
    message 
}) => {
    const spinner = (
        <StyledSpinnerContainer>
            <StyledSpinner size={size} />
            {message && <div className="spinner-message">{message}</div>}
        </StyledSpinnerContainer>
    );

    if (overlay) {
        return (
            <StyledSpinnerOverlay>
                {spinner}
            </StyledSpinnerOverlay>
        );
    }

    return spinner;
};
